import { render, staticRenderFns } from "./AuditList.vue?vue&type=template&id=54b96a51&"
import script from "./AuditList.vue?vue&type=script&lang=js&"
export * from "./AuditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports